import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Package, Camera, CheckCircle } from "@phosphor-icons/react";

const FIELDS = [
  ["chassis", "Chasis"],
  ["part", "Pieza"],
  ["brand", "Marca"],
  ["model", "Modelo"],
  ["year", "Año"],
];

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("es-DO", { dateStyle: "short", timeStyle: "short" }) : "");

export const PartsQuoteCard = ({ conversationId, data }) => {
  const [pq, setPq] = useState(data);
  const [busy, setBusy] = useState(false);

  const markSent = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/conversations/${conversationId}/parts-quote/sent`);
      setPq(r.data.parts_quote);
      toast.success("Cotización marcada como enviada");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo marcar la cotización");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-4 mt-3 rounded-lg border border-primary/30 bg-primary/5 p-3" data-testid="parts-quote-card">
      <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary">
          <Package size={14} weight="duotone" /> Cotización de pieza
          {pq.photo_received && (
            <span className="inline-flex items-center gap-1 rounded-full bg-amber-500/15 text-amber-600 px-2 py-0.5 text-[10px] normal-case tracking-normal" data-testid="parts-quote-photo-badge">
              <Camera size={11} /> Foto recibida
            </span>
          )}
        </div>
        {pq.quote_sent_at ? (
          <span className="inline-flex items-center gap-1 text-[11px] text-emerald-600" data-testid="parts-quote-sent-status">
            <CheckCircle size={13} weight="fill" /> Enviada {fmt(pq.quote_sent_at)}{pq.quote_sent_by_name ? ` · ${pq.quote_sent_by_name}` : ""}
          </span>
        ) : (
          <Button size="sm" onClick={markSent} disabled={busy} className="h-7 text-xs gap-1" data-testid="parts-quote-mark-sent-btn">
            <CheckCircle size={13} /> Cotización enviada
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {FIELDS.map(([k, label]) => (
          <div key={k} className="min-w-0" data-testid={`parts-quote-${k}`}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
            <div className={`text-sm truncate ${k === "chassis" ? "font-mono" : ""}`} title={pq[k] || ""}>
              {pq[k] || <span className="text-muted-foreground italic">pendiente</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
